var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08777 8.7364C4.84209 4.96483 8.15365 2.25 11.9999 2.25C15.8462 2.25 19.1577 4.96483 19.912 8.7364L21.1658 15.0054C21.5686 17.019 20.4996 19.0431 18.6323 19.873C17.9505 20.176 17.2507 20.4298 16.5387 20.6343L16.435 20.8678C15.656 22.6205 13.9179 23.75 11.9999 23.75C10.0819 23.75 8.34382 22.6205 7.56484 20.8678L7.46108 20.6343C6.74912 20.4298 6.0493 20.176 5.36748 19.873C3.50016 19.0431 2.43126 17.019 2.83398 15.0054L4.08777 8.7364ZM9.44866 21.0731C10.0757 21.808 11.0026 22.25 11.9999 22.25C12.9972 22.25 13.9241 21.808 14.5511 21.0731C12.8624 21.3372 11.1374 21.3372 9.44866 21.0731Z",
    fill: "#455A64"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "red"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 4.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.823d8292d1c8755aa3272dd599dafb7e.svg";
export { ForwardRef as ReactComponent };